<template>
  <div class="ui left aligned container">
    <div class="ui form">
      <div class="inline fields">
        <div class="field">
          <label>剧集</label>
          <select v-model="episode" @change="load()">
            <option value=""></option>
            <option value="42">全集</option>
            <option :value="item.episode" :key="item.episode" v-for="item in items">{{ item.name }}</option>
            <option value="41">番外</option>
          </select>
        </div>
        <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
      </div>
    </div>
    <vuetable ref="vuetable"
              :api-url="'/episodes5?interval=' + interval + '&episode=' + this.episode"
              :fields="fields"
              :perPage="42"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://v.qq.com/x/cover/mzc002007x7bcwg/f0045f2dmum.html" target="_blank"> 腾讯视频 </a>
      <a href="https://movie.douban.com/subject/35432425/" target="_blank"> 豆瓣电影 </a>
      <a href="http://piaofang.maoyan.com/tv/1425907" target="_blank"> 猫眼票房 </a>
    </div>
    <div class="ui hidden divider"></div>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="1" v-model="interval" @change="load()">
            <label>1小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="3" v-model="interval" @change="load()">
            <label>3小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="6" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="12" v-model="interval" @change="load()">
            <label>12小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="24" v-model="interval" @change="load()">
            <label>24小时</label>
          </div>
        </div>
      </div>
      <v-chart id="chart" :options="options" theme="light"></v-chart>
    </div>
  </div>
</template>
<style>
</style>
<script>
import Vuetable from '../../table/Vuetable.vue'
import VuetablePagination from '../../table/VuetablePagination.vue'
import axios from 'axios'
import ECharts from 'vue-echarts'

export default {
  name: 'Episode4',
  components: {
    Vuetable,
    VuetablePagination,
    'v-chart': ECharts
  },
  data() {
    return {
      items: [],
      fields: [
        {name: 'episode', title: '集数'},
        {name: 'name', title: '名称'},
        {name: 'txPlay', title: '播放量', callback: 'toText'},
        {name: 'time', title: '时间'},
      ],
      sortOrder: [
        {
          field: 'id',
          direction: 'desc'
        }
      ],
      interval: 1,
      episode: '',
      page: 0,
      options: null,
    }
  },
  mounted() {
    this.items = [...Array(40)].map((_, i) => ({episode: i + 1, name: '重紫_' + (i + 1)}))
    this.load();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage(page) {
      if (page === 'prev') {
        this.page--
      } else if (page === 'next') {
        this.page++
      } else {
        this.page = parseInt(page)
      }
      this.load();
      this.$refs.vuetable.changePage(page)
    },
    load: function () {
      let page = Math.floor(this.page / this.interval);
      axios.get('/episodes5/chart/' + this.episode + '?size=42&page=' + page + '&interval=' + this.interval).then(response => {
        let series = [];
        let legend = [];
        for (let item of response.data) {
          let name = item[0].name;
          series.push({
            name: name,
            type: 'line',
            data: item.map(e => [e.time, e.txInc])
          });
          legend.push(name);
        }
        this.options =
            {
              title: {
                text: '增幅'
              },
              legend: {
                data: legend
              },
              tooltip: {
                trigger: 'axis'
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: series
            };
      });
    },
    refresh: function () {
      this.$refs.vuetable.reload();
      this.load();
    },
    localTime(value) {
      return new Date(value).toLocaleString()
    },
    total(value, row) {
      let txPlay = this.toNumber(row['txPlay']);
      return this.toText(txPlay);
    },
    toNumber(text) {
      if (text.includes("亿")) {
        return +text.replace('亿', '') * 10000;
      }
      return +text.replace('万', '');
    },
    toText(num) {
      if (num >= 1e8) {
        return (num / 1e8).toFixed(4) + '亿';
      }
      return (num / 1e4).toFixed(1) + '万';
    }
  }
}
</script>
